module.exports = __webpack_public_path__ + "img/appointment-type.4f36ad0b.svg";